import { render, staticRenderFns } from "./stocktype.vue?vue&type=template&id=04707084"
import script from "./stocktype.vue?vue&type=script&lang=js"
export * from "./stocktype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports